<template>
    <div>
        <div style="margin:0 -12px;">
            <div class="luna-header-box">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-2">
                            <br>
                            <a href="/event/home">
                                <svg style="height:14px;width:14px;fill:#999;margin-top: -10px;">
                                    <use xlink:href="/images/<.svg#page_left"></use>
                                </svg>
                            </a>
                        </div>
                        <div class="col px-0 text-center">
                            <div style="padding-top:20px; ">
                                <b>管理者権限を共有</b>
                            </div>
                        </div>
                        <div class="col-2">
                        </div>
                    </div>
                </div>
            </div>
            <div class="wrap">
                <div class="container" style="margin-top:60px;">
                    <div class="row">
                        <div class="col">
                            <p class="error-text" v-if="is_err"><i class="bi bi-x-circle-fill"></i>Lunaユーザーのメールアドレスではありません
                            </p>
                            <p class="error-text" v-if="is_err_re"><i class="bi bi-x-circle-fill"></i>すでに共有したメールアドレスです
                            </p>
                            <p class="error-primary" v-if="is_send"><i
                                    class="bi bi-check-circle"></i>入力したメールアドレスへ管理者権限を共有しました
                            </p>
                            <div>
                                <small> メールアドレス </small>
                            </div>
                            <input type="text" class="luna-form-control" v-model="mail" placeholder="入力する" />
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-9">
                            <br />
                            <div class="d-grid gap-2">
                                <button type="button" class="btn btn-luna disabled" style="padding: 12px 0" v-if="is_load">
                                    <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status"
                                        v-if="is_load">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                    送信
                                </button>
                                <button type="button" class="btn btn-luna" style="padding: 12px 0" @click="setEvent()"
                                    id="on-btn" v-else-if="isEventNext()">
                                    送信
                                </button>
                                <button type="button" class="btn btn-luna-d disabled" style="padding: 12px 0" id="non-btn"
                                    v-else>
                                    送信
                                </button>
                            </div>
                        </div>
                    </div>
                    <br>
                    <br>
                    <div class="row" style="background:#E7E7FF;padding:20px 0">
                        <div class="col text-center">
                            <b>共有の流れ</b>
                            <br>
                            <br>
                            <div style="color:#6B4EFF">
                                メールが相手に送信される
                            </div>
                            <img src="/images/Lineunder.png">
                            <div style="color:#6B4EFF">
                                メール内のURLからLunaにログイン
                            </div>
                            <img src="/images/Lineunder.png">
                            <div style="color:#6B4EFF">
                                「イベント管理」ページへ共有
                            </div>
                            <br>
                            <div style="font-size:12px;color:#494C4E">
                                イベントが共有され<br>
                                相手もイベント管理が可能になります
                            </div>
                        </div>
                    </div>
                    <br />
                    <br>
                    <br>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            event_id: "",
            mail: "",
            is_load: false,
            is_err: false,
            is_send: false,
            is_err_re: false,
        };
    },
    methods: {
        isEventNext() {

            //メールアドレスとして判定される文字列と記号の組み合わせを定数化
            const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
            //指定した組み合わせになっていなかった場合判定を返す。

            if (!reg.test(this.mail)) {
                return false
            }

            return true
        },
        async isAuth() {
            await axios.get("/api/auth/user/get")
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました", false)
                    }
                })
        },
        async setEvent() {
            this.is_load = true

            await axios
                .post("/api/event/admin/mail/add", {
                    event_id: this.event_id,
                    mail: this.mail,
                })
                .then((response) => {
                    if (response.data.res == 209) {
                        this.is_err = true
                        this.is_send = false
                        this.is_err_re = false
                    }
                    else if (response.data.res == 208) {
                        this.is_err = false
                        this.is_send = false
                        this.is_err_re = true
                    }
                    else {
                        this.is_err = false
                        this.is_send = true
                        this.is_err_re = false
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        //window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("管理者権限の共有に失敗しました")
                    }
                }).finally(() => {
                    this.is_load = false
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.isAuth()
                            this.event_id = this.$route.params['eid']
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.isAuth()
                this.event_id = this.$route.params['eid']
            }
        }
        else {
            this.isAuth()
            this.event_id = this.$route.params['eid']
        }
    },
};
</script>

<style scoped>
small {
    color: #5538EE;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}


@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}
</style>
